import { getTranslationKeyForTradeStatus } from 'components/Blotters/SecondaryMarketTrade/grid/Grid';
import type { SecondaryTradeStatus } from 'components/Blotters/SecondaryMarketTrade/grid/Model';
import { ListGroup, ListGroupItem } from 'components/shared/ListGroup';
import { QuoteRepriceLink } from 'components/shared/QuoteRepriceLink';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { displayDateFormatOptions } from 'utils/date';

import type { SelectedItem } from '../Component.connect';

export const PanelDetails: FC<{ item: SelectedItem }> = ({
  item: {
    quoteId,
    isin,
    user,
    fileCode,
    salesCounterpart,
    custodian,
    status,
    currency,
    notional,
    maturityDate,
    tradeDate,
  },
}) => {
  const { formatNumber, formatDate, formatMessage } = useIntl();

  return (
    <ListGroup className="mt-3 overflow-y-auto">
      <ListGroupItem key="QuoteId" labelKey="secondaryMarketBlotter.details.quoteId" className="ps-0 pe-3">
        <b>
          <QuoteRepriceLink quoteId={quoteId} externalQuoteId={quoteId} canCopy={false} disabled />
        </b>
      </ListGroupItem>
      <ListGroupItem key="Isin" labelKey="secondaryMarketBlotter.details.isin" className="ps-0 pe-3">
        {isin}
      </ListGroupItem>
      <ListGroupItem key="fileCode" labelKey="secondaryMarketBlotter.details.fileCode" className="ps-0 pe-3">
        {fileCode ?? '_'}
      </ListGroupItem>
      <ListGroupItem key="user" labelKey="secondaryMarketBlotter.details.user" className="ps-0 pe-3">
        <span title={user}>{user}</span>
      </ListGroupItem>
      <ListGroupItem
        key="salesCounterpart"
        labelKey="secondaryMarketBlotter.details.salesCounterpart"
        className="ps-0 pe-3"
      >
        <span title={salesCounterpart}>{salesCounterpart}</span>
      </ListGroupItem>
      <ListGroupItem key="custodian" labelKey="secondaryMarketBlotter.details.custodian" className="ps-0 pe-3">
        <span title={custodian}>{custodian}</span>
      </ListGroupItem>
      <ListGroupItem key="status" labelKey="secondaryMarketBlotter.details.status" className="ps-0 pe-3">
        {formatMessage({ id: getTranslationKeyForTradeStatus(status as SecondaryTradeStatus) })}
      </ListGroupItem>
      <ListGroupItem key="currency" labelKey="secondaryMarketBlotter.details.currency" className="ps-0 pe-3">
        {currency}
      </ListGroupItem>
      <ListGroupItem key="notional" labelKey="secondaryMarketBlotter.details.notional" className="ps-0 pe-3">
        {formatNumber(notional, { maximumFractionDigits: 2 })}
      </ListGroupItem>
      <ListGroupItem key="maturityDate" labelKey="secondaryMarketBlotter.details.maturityDate" className="ps-0 pe-3">
        {formatDate(maturityDate, displayDateFormatOptions)}
      </ListGroupItem>
      <ListGroupItem key="tradeDate" labelKey="secondaryMarketBlotter.details.tradeDate" className="ps-0 pe-3">
        {formatDate(tradeDate, displayDateFormatOptions)}
      </ListGroupItem>
    </ListGroup>
  );
};

PanelDetails.displayName = 'PanelDetails';
